export default __webpack_public_path__ + "static/media/leiloeiros.7e0226eb.png";